interface HeaderProps {
  isPro: boolean;
  licenseKey: string | null;
  busy: boolean;
  onUpgradeClick: () => void;
}

export function Header({ isPro, licenseKey, busy, onUpgradeClick }: HeaderProps) {
  return (
    <header className="border-b border-slate-800/80 bg-slate-950/80">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-4 py-3.5">
        <div className="flex items-center gap-2.5">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-500 text-lg font-black text-slate-950">
            🐵
          </span>
          <div>
            <h1 className="text-sm font-bold tracking-tight text-slate-100">
              ChaosMonkey CSV
            </h1>
            <p className="text-[11px] text-slate-500">
              audit · repair · generate · break-it {busy && <span className="text-amber-400">· working…</span>}
            </p>
          </div>
        </div>
        <div className="ml-auto flex items-center gap-2">
          {isPro ? (
            <span
              title={licenseKey ?? ''}
              className="rounded-full bg-lime-500/15 px-2.5 py-1 text-[11px] font-semibold text-lime-300 ring-1 ring-lime-500/30"
            >
              PRO
            </span>
          ) : (
            <button
              type="button"
              onClick={onUpgradeClick}
              className="rounded-lg bg-amber-500 px-3 py-1.5 text-xs font-bold text-slate-950 transition hover:bg-amber-400"
            >
              Upgrade to Pro
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
